/**
 * useIsActive — true quando il path corrente coincide col path dato o ne è
 * un sotto-percorso.
 *
 * Estratto da Navbar.tsx il 26 Ott 2026 (punto 7: refactor dei monoliti) per
 * essere condiviso dai componenti di navigazione senza duplicare la logica.
 */
import { useLocation } from "react-router-dom";

export function useIsActive() {
  const location = useLocation();
  return (path: string) =>
    location.pathname === path || location.pathname.startsWith(`${path}/`);
}

export default useIsActive;
